export var ruleEngineRelativePath = "/rules";
export var createRuleEngineApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + ruleEngineRelativePath;
    var ruleReorderUrl = apiUrl + "/reorder";
    var ruleUrl = function (id) { return apiUrl + "/" + id; };
    var ruleEnableUrl = function (id) { return ruleUrl(id) + "/enable"; };
    var ruleDisableUrl = function (id) { return ruleUrl(id) + "/disable"; };
    return {
        getRules: function () { return http.get(apiUrl); },
        addRule: function (rule) { return http.post(apiUrl, rule); },
        updateRule: function (rule) { return http.put(ruleUrl(rule.id), rule); },
        enableRule: function (rule) { return http.post(ruleEnableUrl(rule.id), rule); },
        disableRule: function (rule) { return http.post(ruleDisableUrl(rule.id), rule); },
        deleteRule: function (rule) { return http.delete(ruleUrl(rule.id)); },
        reorderRules: function (dto) { return http.post(ruleReorderUrl, dto); }
    };
};
//# sourceMappingURL=index.js.map